import {
    NotificationComponentConfig,
    UserDefinedNotification,
    UserDefinedNotificationConfig,
    UserDefinedNotificationTrigger,
    UserDefinedNotificationTriggerTriggerType,
} from '@apis/Notification/model';
import { QueryExpr } from '@apis/Resources';
import { singleton } from 'tsyringe';
import { EventEmitter } from '../EventEmitter';

export interface INotificationViewerOpenRequest {
    typePrefId?: number;
    notificationId?: number;
    recipientUserId?: number;
    mode: 'view' | 'edit';
    onClose?: (changed: boolean) => void;
    scope: {
        datasourceName?: string;
        /**
         * Configuration for seeding a new notification
         */
        config?: UserDefinedNotificationConfig;
    };
    processed?: boolean;
}
@singleton()
export class NotificationViewerService {
    public readonly openRequested = new EventEmitter<INotificationViewerOpenRequest | undefined>(undefined);
    public readonly onRead = new EventEmitter<UserDefinedNotification | undefined>(undefined);
    public readonly onSaved = new EventEmitter<number | undefined>(undefined);

    public open = (request: INotificationViewerOpenRequest) => {
        this.openRequested.emit(request);
    };

    public view = (notificationId: number, recipientUserId?: number) => {
        this.open({ mode: 'view', notificationId, recipientUserId, scope: {} });
    };

    public create = (
        datasourceName: string,
        options: {
            title?: string;
            componentConfig?: Partial<NotificationComponentConfig>;
            filters?: QueryExpr[];
            trigger?: UserDefinedNotificationTrigger | UserDefinedNotificationTriggerTriggerType;
            presetId?: string;
        }
    ) => {
        const { componentConfig, filters, presetId: rawPresetId, title, trigger: rawTrigger } = options;
        const trigger = typeof rawTrigger === 'string' ? { TriggerType: rawTrigger } : rawTrigger;
        const presetId = rawPresetId ?? [datasourceName, 'custom', trigger?.TriggerType === 'Threshold' ? 'alert' : 'report'].join('-');
        this.open({
            mode: 'edit',
            scope: {
                datasourceName,
                config: {
                    Title: title,
                    ComponentConfig: {
                        Type: 'Chart',
                        ...componentConfig,
                    },
                    Trigger: {
                        Schedule: trigger?.TriggerType !== 'Schedule' ? {} : undefined,
                        Threshold: trigger?.TriggerType !== 'Threshold' ? {} : undefined,
                        ...trigger,
                    },
                    PresentationOptions: { presetId },
                    QueryOptions: {
                        DatasourceName: datasourceName,
                        Filters: filters ?? [],
                    },
                },
            },
        });
    };
}
